<!-- An tag for stylists to quickly see if a style color has been rented before by the customer when they are impersonating a customer. -->
<template>
  <SequinTag
    variant="info"
    class="tag">
    <SvgCaseFilled
      v-if="inRentalHistory"
      width="12"
      height="12"/>
    <SvgCase
      v-else
      width="12"
      height="12"/>
  </SequinTag>
</template>

<script setup>
import { computed } from 'vue'
import SequinTag from '@/components/global/sequin/SequinTag.vue'
import SvgCase from '@/components/global/svg/SvgCase.vue'
import SvgCaseFilled from '@/components/global/svg/SvgCaseFilled.vue'
import { useStylingStore } from '@/stores/styling'
import { storeToRefs } from 'pinia'

const props = defineProps({
  styleColor: {
    type: Object,
    required: true
  },
  /** @type {PropType<StyleColorSource>} */
  styleColorSource: {
    type: Object,
    required: true
  },
  styleColorSourceIndex: {
    type: Number,
    default: () => null
  },
  size: {
    type: String,
    default: 'medium',
    validator: value => ['x-large', 'large', 'medium', 'small', 'tiny'].includes(value)
  }
})

const store = useStylingStore()
const { rentalHistory } = storeToRefs(store)

const inRentalHistory = computed(() => rentalHistory.value?.includes(props.styleColor.id) ?? false)
</script>

<style lang="scss" scoped>
@import './StyleColorQuickActions.scss';
</style>
